import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { Document } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { FooterComponent } from 'ddmo-storybook-lib';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-footer-layout',
    imports: [FooterComponent],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponentLayout {

  @ViewChild('footerRef', { read: ElementRef }) footerRef!: ElementRef;
  
  address: any;
  links: any;
  copyright: any;
  information: any;
  facebook: any;
  footerSite: any = "Missouri";
  X: any;
  linkedIn: any;
  youtube: any;
  instagram: any;
  pinterest: any;
  phone: any;
  userName!: string;
  impersonatedUser!: string;
  isLoggedin!: any
  constructor(private router: Router, private sharedService: SharedService,private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
    this.userName = localStorage.getItem("userName") ?? ""
    let footerData = localStorage.getItem('footerEntries')
    this.isLoggedin = localStorage.getItem("isLoggedin")
    if (this.isLoggedin == "true" && footerData) {
      this.setFooter(JSON.parse(footerData))
    } else if (this.isLoggedin == "false" || !localStorage.getItem("footerEntries")) {
      this.sharedService.setFooter(true).then((res: any) => {
        if (res == "done") {
          footerData = localStorage.getItem('footerEntries')
          let footerEntries = footerData ? JSON.parse(footerData) : "";
          this.setFooter(footerEntries)
        }
      }, (error) => { })
    }
  }

 setFooter(footerEntries: any) {
   let entry = (footerEntries as any)[0].fields;
   if (this.isLoggedin =="false" && entry?.credentialingMaintenanceMode) {
     this.clearLocalData();
     window.location.href = 'https://maintenance.deltadentalmo.com';
   }
   let innerHtml = documentToHtmlString(entry.address as Document);
   if (innerHtml.includes("South Carolina")) {
     this.footerSite = "SC"
     const firstClosingPIndex = innerHtml.indexOf("</p>");
     if (firstClosingPIndex !== -1) {
       innerHtml = `${innerHtml.slice(0, firstClosingPIndex + 4)}<br>${innerHtml.slice(firstClosingPIndex + 4)}`;
     }
   }
   this.address = "<div style='font-size: 13.3px;'>Delta Dental of Missouri does business in South Carolina as Delta Dental of South Carolina.</div><br>"+
   innerHtml;
   localStorage.setItem('address', this.address);

   this.links = documentToHtmlString(entry.links as Document);
   localStorage.setItem('links', this.links);

   this.copyright = documentToHtmlString(entry.copyright as Document);
   localStorage.setItem('copyright', this.copyright);
   
   const rawHtml = documentToHtmlString(entry.information as Document)

   this.information = this.sanitizer.bypassSecurityTrustHtml(rawHtml);

   localStorage.setItem('information', this.information);

   this.facebook = entry.facebook;
   localStorage.setItem('facebook', this.facebook);

   this.X = entry.twitter;
   localStorage.setItem('X', this.X);

   this.linkedIn = entry.linkedin;
   localStorage.setItem('linkedIn', this.linkedIn);

   this.youtube = entry.youtube;
   localStorage.setItem('youtube', this.youtube);

   this.instagram = entry.instagram;
   localStorage.setItem('instagram', this.instagram);

   this.pinterest = entry.pinterest;
   localStorage.setItem('pinterest', this.pinterest);

   this.phone = entry.phone;
   localStorage.setItem('phone', this.phone);

 }
 clearLocalData() {
  localStorage.clear();
  sessionStorage.clear()
  this.clearAllCookies();
}
clearAllCookies() {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
  }
}
ngAfterViewInit() {
  this.footerRef.nativeElement.addEventListener('click', (event: any) => {
    const link = event.target.closest('a');
    if (link) {
      event.preventDefault();
      let routeUrl = this.router.url;
      if(routeUrl.includes('landing')){
        routeUrl = '/landing'
      }
      let linkUrl = this.extractPath(link.href,routeUrl)
      this.sharedService.callUserAudit(linkUrl);
      setTimeout(()=>{
        window.location.href = link.href;
      },500)
    }
  });
}
extractPath(url:string,routerUrl:any){
  if(!url)return routerUrl;
  try{
    const parsed = new URL(url);
    return this.formatPath(parsed.pathname);
  }
  catch{
    return this.formatPath(url)
  }
}

formatPath(path:string):string{
  return path.startsWith('/') ? path: '/' + path;
}
}
